import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PricingRuleIcon } from 'components/common/icons';
import { Col, Divider, EditableInfoComponent, Row, Typography } from 'components';
import { EditPricing } from './edit';
import { usePricing } from './usePricing';

const { Text } = Typography;

export const CountryPricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { updateModalState, onUpdateModalStateChange, dataToEdit } = usePricing();
  return (
    <>
      <EditableInfoComponent
        title={'Country Pricing Rules'}
        editable={hasAccess(PERMISSIONS.countries.pricing_rules.write)}
        icon={<PricingRuleIcon />}
        onEdite={onUpdateModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Text type={'secondary'}>Margin</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {dataToEdit.markup !== null && dataToEdit.markup !== undefined ? `${dataToEdit.markup}%` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Divider style={{ margin: 0, padding: 0, borderColor: '#E1E4EA' }} />
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Text type={'secondary'}>Margin Range</Text>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {dataToEdit.minMargin !== null &&
                dataToEdit.minMargin !== undefined &&
                dataToEdit.maxMargin !== null &&
                dataToEdit.maxMargin !== undefined
                  ? `${dataToEdit.minMargin}-${dataToEdit.maxMargin}%`
                  : dataToEdit.minMargin !== null && dataToEdit.minMargin !== undefined
                    ? `${dataToEdit.minMargin} Min`
                    : dataToEdit.maxMargin !== null && dataToEdit.maxMargin !== undefined
                      ? `${dataToEdit.maxMargin} Max`
                      : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <EditPricing
        modalState={updateModalState}
        onModalStateChange={onUpdateModalStateChange}
        dataToEdit={dataToEdit}
      />
    </>
  );
});
